import AuraMark from "@/components/brand/AuraMark";
import { Instagram, Linkedin, Youtube, Twitter, Mail, Phone } from "lucide-react";
import { FOOTER } from "@/constants/testIds";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

const quickLinks = [
  { id: "tracks", label: "Event Tracks" },
  { id: "events", label: "Upcoming Events" },
  { id: "corporate", label: "Corporate Events" },
  { id: "partners", label: "Partner With Us" },
  { id: "enquiry", label: "Contact" },
];

const socials = [
  { icon: Instagram, label: "Instagram", href: "#" },
  { icon: Linkedin, label: "LinkedIn", href: "#" },
  { icon: Youtube, label: "YouTube", href: "#" },
  { icon: Twitter, label: "X / Twitter", href: "#" },
];

export default function Footer() {
  return (
    <footer
      data-testid={FOOTER.section}
      className="bg-[var(--aura-charcoal)] text-[var(--aura-ivory)] pt-16 pb-8"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3">
            <AuraMark size={32} />
            <span className="font-display text-2xl">
              Aura <span className="text-[var(--aura-sage)]">Events</span>
            </span>
          </div>
          <p className="mt-5 font-body text-sm text-[var(--aura-ivory)]/75 max-w-md">
            Aura Events curates modern experiences across lifestyle, wellness,
            technology, business, creativity, learning, community, and culture.
          </p>

          <div className="mt-6 flex flex-col gap-2 font-body text-sm text-[var(--aura-ivory)]/80">
            <a href="mailto:hello@auraevents.com" className="inline-flex items-center gap-2 hover:text-[var(--aura-ivory)]">
              <Mail size={14} /> hello@auraevents.com
            </a>
            <span className="inline-flex items-center gap-2">
              <Phone size={14} /> +91 · phone announcing soon
            </span>
          </div>

          <div className="mt-6 flex gap-3">
            {socials.map(({ icon: Icon, label, href }) => (
              <a
                key={label}
                href={href}
                aria-label={label}
                className="w-9 h-9 rounded-full border border-white/15 flex items-center justify-center hover:bg-white/10 transition-colors"
              >
                <Icon size={15} />
              </a>
            ))}
          </div>
        </div>

        <div className="lg:col-span-3">
          <div className="font-ui text-xs uppercase tracking-[0.2em] text-[var(--aura-ivory)]/60">
            Explore
          </div>
          <ul className="mt-4 space-y-2 font-body text-sm">
            {quickLinks.map((l) => (
              <li key={l.id}>
                <button
                  onClick={() => scrollTo(l.id)}
                  className="text-[var(--aura-ivory)]/85 hover:text-[var(--aura-ivory)]"
                >
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-4">
          <div className="font-ui text-xs uppercase tracking-[0.2em] text-[var(--aura-ivory)]/60">
            Disclaimer
          </div>
          <p className="mt-4 font-body text-xs text-[var(--aura-ivory)]/60 leading-relaxed">
            Aura Events creates general educational, lifestyle, professional,
            and community experiences. Wellness content is for general
            information only and is not medical advice. Please consult qualified
            professionals for personal medical or health concerns.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14 mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs font-body text-[var(--aura-ivory)]/50">
        <div>© {new Date().getFullYear()} Aura Events. All rights reserved.</div>
        <div className="italic">Events that move people forward.</div>
      </div>
    </footer>
  );
}
